module.exports = __webpack_public_path__ + "static/media/pic3.24156d7e.png";